import React, { useEffect, useState } from "react";
import Loader from "../../VibehutUI/Loader";
import HomePage from "../../pages/HomePage";

const HomePageWrapper = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    let loggingCallbackUrl =
      window.localStorage.getItem("loggingCallbackUrl") || "";
    if (loggingCallbackUrl) {
      localStorage.removeItem("loggingCallbackUrl");
      window.open(loggingCallbackUrl, "_self");
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div className="text-center mt-52">{<Loader />}</div>;
  }

  return <HomePage />;
};

export default HomePageWrapper;
